<div class="form-group row">
  <label [attr.for]="id" class="col-sm-3 col-form-label mat-form-horizontal-field-label" *ngIf="to.label">
    {{ to.label }}
    <ng-container *ngIf="to.required && to.hideRequiredMarker !== true">*</ng-container>
  </label>
  <div class="col-sm-7">
    <ng-template #fieldComponent></ng-template>
  </div>

  <div *ngIf="showError" class="col-sm-3 invalid-feedback d-block">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
</div>